var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.351267,
    y: 1.03291,
    width: 27.0422,
    height: 27.0422,
    rx: 8.90413,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.351267,
    y: 1.03291,
    width: 27.0422,
    height: 27.0422,
    rx: 8.90413,
    stroke: "#E2E2EA",
    strokeWidth: 0.659565
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_22533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5566 8.39062V10.2044",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3945 8.39062V10.2044",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53516 11.9351C8.53516 10.4781 9.71635 9.29688 11.1734 9.29688H16.7797C18.2368 9.29688 19.418 10.4781 19.418 11.9351V17.8437C19.418 19.3008 18.2368 20.482 16.7797 20.482H11.1734C9.71635 20.482 8.53516 19.3008 8.53516 17.8437V11.9351Z",
    stroke: "#A461D8",
    strokeWidth: 0.989347
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1621 16.2483L13.1808 17.0632C13.4564 17.2837 13.8568 17.2481 14.0892 16.9825L15.7897 15.0391",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53516 12.6211H19.418",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_22533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5104,
    height: 14.5104,
    fill: "white",
    transform: "translate(6.7207 7.17969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderOutline);
export default __webpack_public_path__ + "static/media/calender-outline.18ac859e91be058d5272a64add6e101c.svg";
export { ForwardRef as ReactComponent };